import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useApiCaller } from '../../utils/ApiUtilities';
import { getPublicTopPerformersUrl } from '../../utils/UrlUtilities';
import { TAGLEVELS } from '../../utils/Constants';
import PagedCarousel from './PagedCarousel';

// Flatten TAGLEVELS (including submenu leaves) into concrete level options.
function flattenLevels() {
    const out = [];
    for (const item of TAGLEVELS) {
        if (item.submenu && item.submenu.length > 0) {
            item.submenu.forEach(sub => out.push({ label: sub.label, value: sub.value }));
        } else {
            out.push({ label: item.label, value: item.value });
        }
    }
    return out;
}

export default function TopPerformers() {
    const CallApi = useApiCaller();
    const [selected, setSelected] = useState(null);
    const [performers, setPerformers] = useState([]);
    const [loading, setLoading] = useState(false);
    const levels = flattenLevels();

    const handlePick = async (level) => {
        setSelected(level);
        setLoading(true);
        setPerformers([]);
        const res = await CallApi({ url: getPublicTopPerformersUrl(level, 5), method: 'GET', token: false });
        if (res.success) setPerformers(res.data?.performers || []);
        setLoading(false);
    };

    return (
        <div className="my-5">
            <h2 className="text-center mb-4 fw-bold" style={{ color: '#4c1d95' }}>🏆 Top Performers</h2>

            <PagedCarousel pageSize={6} interval={2000}>
                {levels.map(l => (
                    <button
                        key={l.value}
                        onClick={() => handlePick(l.value)}
                        className="kp-card-hover"
                        style={{
                            width: 180,
                            minHeight: 90,
                            border: selected === l.value ? '2px solid #7c3aed' : '1px solid #ede9fe',
                            background: selected === l.value ? 'linear-gradient(145deg,#ede9fe,#ddd6fe)' : '#ffffff',
                            borderRadius: '0.75rem',
                            padding: '1rem',
                            cursor: 'pointer',
                            fontWeight: 700,
                            color: '#4c1d95',
                        }}
                    >
                        {l.label}
                    </button>
                ))}
            </PagedCarousel>

            {selected && (
                <div className="card mt-4 mx-auto" style={{ maxWidth: 720, borderColor: '#ede9fe' }}>
                    <div className="card-header" style={{ background: 'linear-gradient(145deg,#7c3aed,#5b21b6)', color: '#fff', fontWeight: 700 }}>
                        Top Performers — {selected} (Competition)
                    </div>
                    <div className="card-body">
                        {loading ? (
                            <div className="text-center text-muted py-3">Loading…</div>
                        ) : performers.length === 0 ? (
                            <div className="text-center text-muted py-3">No competition results published for {selected} yet.</div>
                        ) : (
                            <>
                                {performers[0] && (
                                    <div className="alert alert-warning text-center mb-3" style={{ fontSize: '1.05rem' }}>
                                        🏅 <strong>{performers[0].name}</strong>
                                        {performers[0].institute ? ` from ${performers[0].institute}` : ''}
                                        {' '}scored <strong>{performers[0].score_pct}%</strong> on {performers[0].quiz_title}
                                    </div>
                                )}
                                <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th><th>Name</th><th>Institute</th><th>Test</th><th className="text-end">Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {performers.map(p => (
                                            <tr key={p.position}>
                                                <td>{p.position}</td>
                                                <td>{p.name}</td>
                                                <td>{p.institute || '—'}</td>
                                                <td>{p.quiz_title}</td>
                                                <td className="text-end fw-bold">{p.score_pct}%</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                </div>
                            </>
                        )}
                        <div className="text-center mt-3">
                            <Link to="/login" className="btn btn-sm btn-outline-primary">Log in to view the full list →</Link>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
